import React, { useEffect } from 'react';

import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'recompose';

import { accountActions } from '../../../actions/account.actions';
import { OktaProps } from '../../../components/Auth/Okta/types';
import Loading from '../../Loading';

type Props = MappedDispatch & RouteComponentProps & OktaProps;
const AcceptInvitationPrivate = ({ logout, history, location, oktaAuth, authState }: Props) => {
  useEffect(() => {
    const { pathname, search } = location;
    if (oktaAuth && authState?.accessToken) {
      oktaAuth.session.close();
      oktaAuth.signOut();
    }
    logout();
    setTimeout(() => {
      history.replace({
        pathname,
        search,
      });
    }, 10);
  }, []);

  return <Loading fullscreen />;
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (dispatch: ThunkDispatch) => {
  return {
    logout: () => {
      dispatch(accountActions.logout());
    },
  };
};

export default compose<Props, {}>(
  withRouter,
  connect(null, mapDispatchToProps),
  withOktaAuth
)(AcceptInvitationPrivate);
